import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'rename-dialog',
  templateUrl: './rename-dialog.component.html',
  styleUrls: ['./rename-dialog.component.scss']
})
export class RenameDialogComponent {
  renameForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RenameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { existingName: string }
  ) {
    this.renameForm = this.fb.group({
      newName: [this.data.existingName, [Validators.required, Validators.pattern(/^(?!.*\s\s)(?!^\s)(?!.*\s$)[a-zA-Z0-9 ,.\-_]{1,50}$/), this.notSameAsExisting.bind(this)]]
    });
  }

  notSameAsExisting(control: FormControl) {
    return control.value !== this.data.existingName ? null : { sameAsExisting: true };
  }

  onRename() {
    if (this.renameForm.valid) {
      this.dialogRef.close(this.renameForm.value.newName);
    }
  }
}
